import { render, staticRenderFns } from "./shopOption.vue?vue&type=template&id=ecf4e15a&scoped=true"
import script from "./shopOption.vue?vue&type=script&lang=js"
export * from "./shopOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf4e15a",
  null
  
)

export default component.exports